import React, { useState, useEffect } from "react";
import { Input, Switch, Divider } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useProjectState } from "../../../../context/stateContext";

const EditTabsDeliverySettings = ({
  sendDeliveryState,
  organization,
  modes,
}) => {
  const [deliveryEnabled, setDeliveryEnabled] = useState(null);
  const [invoiceEnabled, setInvoicEnabled] = useState(null);
  const [headerDeliveryText, setHeaderDeliveryText] = useState(null);
  const [rawInput, setRawInput] = useState(""); // Track raw input separately
  const [deliveryItemId, setDeliveryItemId] = useState(null);
  const [deliveryItemStationId, setDeliveryItemStationId] = useState(null);
  const [freeDeliveryTreshhold, setFreeDeliveryTreshhold] = useState(null);
  const [estimatedDeliveryTimeMinutes, setEstimatedDeliveryTimeMinutes] =
    useState(null);
  const [deliveryPrice, setDeliveryPrice] = useState(null);
  const [pickUpAddressBulgarian, setPickUpAddressBulgarian] = useState(null);
  const [pickUpAddressEnglish, setPickUpAddressEnglish] = useState(null);
  const [autoAcceptOrdersCount, setAutoAcceptOrdersCount] = useState(null);
  const [choosePaymentTypeEnabled, setChoosePaymentTypeEnabled] =
    useState(null);
  const { openEditOrganizationModal } = useProjectState();

  const deliveryState = {
    deliveryEnabled,
    invoiceEnabled,
    choosePaymentTypeEnabled,
    headerDeliveryText,
    deliveryItemId,
    deliveryItemStationId,
    freeDeliveryTreshhold,
    estimatedDeliveryTimeMinutes,
    deliveryPrice,
    pickUpAddressBulgarian,
    pickUpAddressEnglish,
    autoAcceptOrdersCount,
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    setRawInput(inputValue);

    const splitValues = inputValue.split(",").map((item) => item.trim());
    setHeaderDeliveryText(splitValues);
  };

  useEffect(() => {
    sendDeliveryState(deliveryState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(deliveryState)]);

  useEffect(() => {
    setDeliveryEnabled(
      organization?.myMenuConfiguration?.deliveryConfiguration?.deliveryEnabled
    );

    setInvoicEnabled(
      organization?.myMenuConfiguration?.deliveryConfiguration?.invoiceEnabled
    );

    setChoosePaymentTypeEnabled(
      organization?.myMenuConfiguration?.deliveryConfiguration
        ?.choosePaymentTypeEnabled
    );

    setHeaderDeliveryText(
      organization?.myMenuConfiguration?.deliveryConfiguration
        ?.headerDeliveryText
    );

    setRawInput(
      organization?.myMenuConfiguration?.deliveryConfiguration
        ?.headerDeliveryText
    );

    setDeliveryItemId(
      organization?.myMenuConfiguration?.deliveryConfiguration?.deliveryItemId
    );

    setDeliveryItemStationId(
      organization?.myMenuConfiguration?.deliveryConfiguration
        ?.deliveryItemStationId
    );

    setFreeDeliveryTreshhold(
      organization?.myMenuConfiguration?.deliveryConfiguration
        ?.freeDeliveryTreshhold
    );

    setEstimatedDeliveryTimeMinutes(
      organization?.myMenuConfiguration?.deliveryConfiguration
        ?.estimatedDeliveryTimeMinutes
    );

    setDeliveryPrice(
      organization?.myMenuConfiguration?.deliveryConfiguration?.deliveryPrice
    );

    setPickUpAddressBulgarian(
      organization?.myMenuConfiguration?.deliveryConfiguration
        ?.pickUpAddressBulgarian
    );

    setPickUpAddressEnglish(
      organization?.myMenuConfiguration?.deliveryConfiguration
        ?.pickUpAddressEnglish
    );

    setAutoAcceptOrdersCount(
      organization?.myMenuConfiguration?.deliveryConfiguration
        ?.autoAcceptOrdersCount
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization, openEditOrganizationModal]);

  useEffect(() => {
    if (modes === 1 || modes === "Ordering + Delivery") {
      setDeliveryEnabled(true);
    } else if (modes === 2 || modes === 0 || modes === 3) {
      setDeliveryEnabled(false);
    }
  }, [modes]);

  return (
    <>
      <div className="admin-organization-edit-sections">
        <div>
          <label
            style={{ width: "300px" }}
            className="admin-organization-edit-input-label"
          >
            Доставки
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={deliveryEnabled}
            onChange={(value) => setDeliveryEnabled(value)}
          />
        </div>
        <div>
          <label
            style={{ width: "300px" }}
            className="admin-organization-edit-input-label"
          >
            Детайли за фактуриране
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={invoiceEnabled}
            onChange={(value) => setInvoicEnabled(value)}
          />
        </div>
      </div>
      {deliveryEnabled && (
        <>
          <Divider />
          <div>
            <label
              style={{ width: "300px" }}
              className="admin-organization-edit-input-label"
            >
              Избере начин на плащане
            </label>
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              checked={choosePaymentTypeEnabled}
              onChange={(value) => setChoosePaymentTypeEnabled(value)}
            />
          </div>
          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Header текст
              </label>
              <Input value={rawInput} onChange={handleChange} />
            </div>
          </div>
          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                ID на продукт за доставка
              </label>
              <Input
                value={deliveryItemId}
                onChange={(e) => setDeliveryItemId(e.target.value)}
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                ID на обекта за изпълнение
              </label>
              <Input
                value={deliveryItemStationId}
                onChange={(e) => setDeliveryItemStationId(e.target.value)}
              />
            </div>
          </div>
          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Безплатна доставка над
              </label>
              <Input
                value={freeDeliveryTreshhold}
                onChange={(e) => setFreeDeliveryTreshhold(e.target.value)}
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Цена на доставка
              </label>
              <Input
                value={deliveryPrice}
                onChange={(e) => setDeliveryPrice(e.target.value)}
              />
            </div>
          </div>
          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Време на доставка
              </label>
              <Input
                value={estimatedDeliveryTimeMinutes}
                onChange={(e) =>
                  setEstimatedDeliveryTimeMinutes(e.target.value)
                }
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Автоматично приемане на поръчки след
              </label>
              <Input
                value={autoAcceptOrdersCount}
                onChange={(e) => setAutoAcceptOrdersCount(e.target.value)}
              />
            </div>
          </div>
          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Вземи от ресторант (BG)
              </label>
              <Input
                value={pickUpAddressBulgarian}
                onChange={(e) => setPickUpAddressBulgarian(e.target.value)}
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                Вземи от ресторант (EN)
              </label>
              <Input
                value={pickUpAddressEnglish}
                onChange={(e) => setPickUpAddressEnglish(e.target.value)}
              />
            </div>
          </div>
        </>
      )}
      <Divider />
    </>
  );
};

export default EditTabsDeliverySettings;
